import { useState } from "react"

const STORAGE_KEY = "dimpet.cookies"

function readStoredChoice(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) !== null
  } catch {
    // Safari em navegacao privada lanca ao ler localStorage. Nesse caso o
    // banner reaparece a cada visita — melhor que a pagina nao renderizar.
    return false
  }
}

function storeChoice(choice: "aceito" | "recusado"): void {
  try {
    localStorage.setItem(STORAGE_KEY, choice)
  } catch {
    /* sem persistencia disponivel — a escolha vale so para esta sessao */
  }
}

/**
 * Aviso de cookies.
 *
 * No prototipo a escolha vivia em `useState` dentro do rodape: o banner voltava
 * a cada recarga, e "Recusar" fazia exatamente o mesmo que "Aceitar". A escolha
 * agora persiste. O site nao carrega rastreador nenhum hoje — quando carregar,
 * e este componente que decide, e "Recusar" precisa continuar significando algo.
 */
export function CookieBanner() {
  const [answered, setAnswered] = useState(readStoredChoice)

  if (answered) return null

  const answer = (choice: "aceito" | "recusado") => {
    storeChoice(choice)
    setAnswered(true)
  }

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 lg:bottom-4 lg:left-4 lg:right-auto lg:max-w-sm"
      role="region"
      aria-label="Aviso de cookies"
    >
      <div className="bg-verde-profundo text-off-white p-5 lg:rounded-2xl lg:shadow-2xl border-t border-off-white/10 lg:border lg:border-off-white/10">
        <p className="text-sm leading-relaxed mb-4 text-off-white/80">
          Usamos cookies para melhorar sua experiência. Ao continuar, você concorda com nossa{" "}
          <a href="#privacidade" className="underline text-dourado-claro hover:text-dourado-escuro">
            Política de Privacidade
          </a>
          .
        </p>

        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => answer("aceito")}
            className="flex-1 h-9 rounded-xl bg-dourado text-white text-sm font-semibold hover:bg-dourado-claro transition-colors cursor-pointer"
          >
            Aceitar
          </button>
          <button
            type="button"
            onClick={() => answer("recusado")}
            className="flex-1 h-9 rounded-xl border border-off-white/20 text-off-white/70 text-sm hover:bg-off-white/5 transition-colors cursor-pointer"
          >
            Recusar
          </button>
        </div>
      </div>
    </div>
  )
}
